import { gql_request, GqlRequestOptions } from '@common/api-request';

export interface GetPdpShopIdVariables {
  catalog_product_id: string;
}

export interface GetPdpShopId {
  catalog_product_base_info: {
    shop: {
      id: string;
    };
  };
}

export function getPdpShopId(variable: GetPdpShopIdVariables, options?: GqlRequestOptions) {
  const query = `
    query GetPdpShopId($catalog_product_id: ID!) {
      catalog_product_base_info: pdp_base_info(catalog_product_id: $catalog_product_id) {
        shop {
          id
        }
      }
    }
  `;
  return gql_request<GetPdpShopId, GetPdpShopIdVariables>('GetPdpShopId', query, variable, {
    use_consumer: true,
    ...options,
  });
}
